import { DefaultLinkModel } from '@projectstorm/react-diagrams'

export default class DuprLinkModel extends DefaultLinkModel {
  constructor(props: any) {
    super({
      selectedColor: 'red',
      color: 'gray',
      ...props,
    })
  }
}
